"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumObject = void 0;
class EnumObject {
    constructor(code) {
        this.code = code;
    }
    is(another) {
        if (another === undefined || another === null) {
            return false;
        }
        if (another instanceof EnumObject) {
            return this.code === another.code;
        }
        if (this.constructor.toString() === another.constructor.toString()) {
            return this.code === another.code;
        }
        return this.code === another;
    }
    isNot(another) {
        return !this.is(another);
    }
    isIn(another) {
        if (another === undefined || another === null) {
            return false;
        }
        const isAny = another.find(a => this.is(a));
        return !!isAny;
    }
    isNotIn(another) {
        return !this.isIn(another);
    }
    isBiggerOrEqualThan(enumValue) {
        return this.code >= enumValue.code;
    }
    isBiggerThan(enumValue) {
        if (enumValue instanceof EnumObject) {
            return this.code > enumValue.code;
        }
        if (this.constructor.toString() === enumValue.constructor.toString()) {
            return this.code > enumValue.code;
        }
        return this.code > enumValue;
    }
    isSmallerOrEqualThan(enumValue) {
        return this.code <= enumValue.code;
    }
    isSmallerThan(enumValue) {
        return this.code < enumValue.code;
    }
}
exports.EnumObject = EnumObject;
//# sourceMappingURL=enum-object.js.map